<div class="mw-100">
    <div class="navStyle">
        <app-navbar></app-navbar>
    </div>
    <div class="row">
        <div class="container">
            <h5 class="customFont1">{{ 'DASHBOARD' | translate }}</h5>
            <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-3 ">
                    <app-card [numb]="datos.deviceConnected" [subTitle]="'DEVICE_CONNECTED' | translate"
                        [icontitle]="'pi pi-mobile'"></app-card>
                </div>
                <div class="p-col-12 p-md-4 p-lg-3" *ngIf="datos.userRegister != undefined">
                    <app-card [numb]="datos.userRegister" [subTitle]="'USER_REGISTERED' | translate" [icontitle]="'pi pi-user'"></app-card>
                </div>
                <div class="p-col-12 p-md-4 p-lg-3 ">
                    <app-card [numb]="datos.messagesAllDevice" [subTitle]="'TOTAL_MESSAGES_DEVICES' | translate" [icontitle]="'pi pi-whatsapp'"></app-card>
                </div>
                <div class="p-col-12 p-md-4 p-lg-3 ">
                    <app-card [numb]="datos.expiredDevices" [subTitle]="'EXPIRED_DEVICES' | translate" [icontitle]="'pi pi-stopwatch'"></app-card>
                </div>
            </div>
        </div>
        <div class="container">
            <app-device-table (recargar)="volverObtenerDatosGenerales()"></app-device-table>
        </div>
    </div>
</div>